import API from "../../../../../global/api";
///get vendor
export const requestVendorData = () => {
    return {
        type: "REQUEST_VENDOR_GET_DATA",
    };
};
export const successVendorGetData = (data) => {
    return {
        type: "SUCCESS_VENDOR_GET_DATA",
        payload: data,
    };
};
export const errorVendorGetData = () => {
    return {
        type: "ERROR_VENDOR_GET_DATA",
    };
};
export const getVendorData = () => {
    return (dispatch) => {
        dispatch(requestVendorData());
        API.get(`/vendor/get_vendor`).then((res) => {
            let getData = res.data;
            console.log(getData,'List')
            dispatch(successVendorGetData(getData));
        }).catch((error) => {
            dispatch(errorVendorGetData());
        })
    };
};
//get po by vedor id
export const requestGetPOByVendorId = () => {
    return {
        type: "REQUEST_GET_PO_BY_VENDOR_ID",
    };
};
export const successGetPOByVendorId = (data) => {
    return {
        type: "SUCCESS_GET_PO_BY_VENDOR_ID",
        payload: data,
    };
};
export const errorGetPOByVendorId = () => {
    return {
        type: "ERROR_GET_PO_BY_VENDOR_ID",
    };
};
export const getCompletePOByVendorId = (id) => {
    return (dispatch) => {
        dispatch(requestGetPOByVendorId());
        API.get(`/purchase/approve_po_with_vendorId/${id}`).then((res) => {
            let getData = res.data;
            console.log(getData,'List')
            dispatch(successGetPOByVendorId(getData));
        }).catch((error) => {
            dispatch(errorGetPOByVendorId());
        })
    };
};
//add vendor
export const requestAddVendor = () => {
    return {
        type: "REQUEST_ADD_VENDOR",
    };
};
export const successAddVendor = (data) => {
    return {
        type: "SUCCESS_ADD_VENDOR",
        payload: data,
    };
};
export const errorAddVendor = () => {
    return {
        type: "ERROR_ADD_VENDOR",
    };
};
export const addVendor = (data, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestAddVendor());
        API.post(`/vendor/add_vendor`, data).then((res) => {
           // 
            dispatch(successAddVendor(data));
            dispatch(getVendorData());
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorAddVendor());
            handleDangerVisible(error.response.data.message);
        })
    };
};
//delete vendor
export const DeleteRequestVendor = () => {
    return {
        type: "DELETE_REQUEST_VENDOR",
    };
};
export const DeleteSuccessVendor = (user_id) => {
    return {
        type: "DELETE_SUCCESS_VENDOR",
        user_id: user_id,
    };
};
export const DeleteErrorVendor = () => {
    return {
        type: "DELETE_ERROR_VENDOR",
    };
};
export const deleteVendor = (vendorId) => {
    return dispatch => {
        dispatch(DeleteRequestVendor());
        API.delete(`/vendor/delete_vendor/${vendorId}`)
            .then(res => {
              //  
                dispatch(DeleteSuccessVendor(vendorId))
                dispatch(getVendorData());
            }).catch((error) =>
            {
                dispatch(DeleteErrorVendor())
    });
    }
};
/// update vendor
export const UpdateRequestVendor = () => {
    return {
        type: "UPDATE_REQUEST_VENDOR",
    };
};
export const UpdateSuccessVendor = (data) => {
    return {
        type: "UPDATE_SUCCESS_VENDOR",
        payload: data,
    };
};

export const UpdateErrorVendor = () => {
    return {
        type: "UPDATE_ERROR_VENDOR",
    };
};

export const updateVendor = (data, oldData) => {
    return dispatch => {
        dispatch(UpdateRequestVendor());
        console.log(data,'hmhm')
        API.put(`/vendor/update_vendor/${oldData.vendorId}`,
            {
                vendorName: data.vendorName,
                vendorCnic:data.vendorCnic,
                vendorPhone:data.vendorPhone,
                vendorAddress:data.vendorAddress,    
            },{
        })
            .then(res => {
               
                dispatch(UpdateSuccessVendor([data]))
                dispatch(getVendorData());
            }).catch((error) =>
                dispatch(UpdateErrorVendor()));
    }
};